import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import PasswordGenerator from '../../components/PasswordGenerator';

const PasswordGen: React.FC = () => (
  <ToolLayout
    title="Password Generator - Create Strong Passwords | AllTools"
    description="Generate strong, secure passwords instantly. Customize length and character types. Free password generator."
    canonicalPath="/password-generator"
  >
    <PasswordGenerator />
  </ToolLayout>
);

export default PasswordGen;
